import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import AppState from "./context/AppState";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, HashRouter } from "react-router-dom";
import { isDesktopApp } from "./utils/isDesktop";
import 'leaflet/dist/leaflet.css';
import 'leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.css';
import 'leaflet-defaulticon-compatibility';
import '../src/assets/fonts/font.css'
const root = ReactDOM.createRoot(document.getElementById("root"));

const RouterComponent = isDesktopApp() ? HashRouter : BrowserRouter;

root.render(
  
  <React.StrictMode>
    <RouterComponent>
    <AppState>
      <App />
    </AppState>
    </RouterComponent>
  </React.StrictMode>
);
reportWebVitals();
